import { TiktokLogo } from '@phosphor-icons/react';

export default TiktokLogo;
